import React from 'react';
import { WorkflowState } from '../../../models/enums/WorkflowState';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';
import WorkflowStateBadge from '../../common/WorkflowStateBadge';
import './ProgressBarBig.css';
import PortOpeningRequest from '../../../models/entities/PortOpeningRequest';

interface ProgressBarBigProps {
	workflowState: WorkflowState;
	porScope: string;
	isAttestation: boolean;
	por: PortOpeningRequest;
}

const ProgressBarBig = ({ workflowState, porScope, isAttestation, por }: ProgressBarBigProps) => {
	const hasProgressBar = (): boolean => {
		const noProgressArray = [WorkflowState.Cancelled, WorkflowState.Rejected];
		return !noProgressArray.some((nws) => nws.value === workflowState.value);
	};

	const activeSOApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			//case WorkflowState.PendingForCloudNetworkApproval.value:
			case WorkflowState.PendingForPolicyTeamApproval.value:
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.PendingApplicationApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.Error.value:
				return 'big-back-blue';
			default:
				return '';
		}
	};

	const activeDOAGApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.Error.value:
				return 'big-back-blue';
			default:
				return '';
		}
	};

	const activeTechnicalApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingApplicationApproval.value:
			case WorkflowState.PendingSolutionArchitectureApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.Error.value:
				return 'big-back-blue';
			default:
				return '';
		}
	};

	const activeArchitectApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingApplicationApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.PendingForCyberApproval.value:
			case WorkflowState.Error.value:
				return !por.architectApprovalBypassed() ? 'big-back-blue' : 'big-back-gray';
			default:
				return '';
		}
	};

	const activeCyberApproval = () => {
		switch (workflowState.value) {
			case WorkflowState.AwaitingImplementation.value:
			case WorkflowState.Completed.value:
			case WorkflowState.PendingApplicationApproval.value:
			case WorkflowState.PendingForDOAGApproval.value:
			case WorkflowState.Error.value:
				return !por.cyberApprovalBypassed() ? 'big-back-blue' : 'big-back-gray';
			default:
				return '';
		}
	};

	return (
		<>
			<div className="big-progress-bar__title">
				<span className="em-c-field__label em-c-field__label--margin">Status</span>
				<WorkflowStateBadge workflowState={workflowState} />
			</div>
			{hasProgressBar() && !isAttestation && (
				<div className={`por-${porScope}-big-progress-bar`}>
					<div className="big-progress-bar__line" />
					{porScope === PortOpeningRequestsDirection.SubscriptionToInternet.name ? (
						<>
							<div className="big-progress-bar__circle-with-title big-left-0">
								<div className={`big-progress-bar__circle ${activeSOApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">SO Approval</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-25">
								<div className={`big-progress-bar__circle ${activeTechnicalApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">Network Policy Approval</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-50">
								<div className={`big-progress-bar__circle ${activeArchitectApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">
									Network Policy Sol. Arch. Approval
								</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-75">
								<div className={`big-progress-bar__circle ${activeCyberApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">Cyber Approval</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-100">
    							<div className={`big-progress-bar__circle ${activeDOAGApproval()}`}>✓</div>
    							<div className="big-progress-bar__circle--title">
        							{por.approvingUser != null ? 'DOAG Approval' : 'Application Approval'}
    							</div>
							</div>
						</>
					) : (
						<>
							<div className="big-progress-bar__circle-with-title big-left-0">
								<div className={`big-progress-bar__circle ${activeSOApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">SO Approval</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-33">
								<div className={`big-progress-bar__circle ${activeTechnicalApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">Network Policy Approval</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-66">
								<div className={`big-progress-bar__circle ${activeArchitectApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">
									Network Policy Sol. Arch. Approval
								</div>
							</div>
							<div className="big-progress-bar__circle-with-title big-left-100">
								<div className={`big-progress-bar__circle ${activeCyberApproval()}`}>✓</div>
								<div className="big-progress-bar__circle--title">Cyber Approval</div>
							</div>
						</>
					)}
				</div>
			)}
		</>
	);
};

export default ProgressBarBig;
